import React from 'react';

import ExpandablePanel from '../../components/interactive/ExpandablePanel';

type FAQWidgetProps = {
  description?: string;
};
const FAQWidget: React.FC<FAQWidgetProps> = (props) => {
  const { description } = props;
  return (
    <div className="flex flex-col gap-8 mb-6">
      <h1>FAQ</h1>
      {description && <p>{description}</p>}
      <div>
        <ExpandablePanel title="Integration Setup" count={3}>
          <FAQPanel
            sections={[
              {
                title: 'How do I integrate Gaspar with my Single Sign-On (SSO) provider?',
                content:
                  'Follow our step-by-step guides for seamless integration with popular SSO providers like Google Workspace and Office 365. Click here for detailed instructions. Follow our step-by-step guides for seamless integration with popular SSO providers like Google Workspace and Office 365. Click here for detailed instructions.',
              },
              {
                title: 'Can I connect Gaspar with multiple messaging platforms simultaneously?',
                content:
                  'Yes, Gaspar supports integration with multiple messaging platforms. Configure your preferences effortlessly to communicate seamlessly across different channels.',
              },
              {
                title: "What ITSM tools are compatible with Gaspar's Admin Portal?",
                content:
                  'Gaspar seamlessly integrates with various ITSM tools, including Jira, ServiceNow, Freshservice, and Asana. Choose the one that aligns with your workflow.',
              },
            ]}
          />
        </ExpandablePanel>
      </div>
    </div>
  );
};
FAQWidget.displayName = 'FAQWidget';
export default FAQWidget;

/************************************************************************************************
 * Helpers
 ************************************************************************************************/

type FAQPanelProps = {
  sections: Array<{ title: string; content: string }>;
};
const FAQPanel: React.FC<FAQPanelProps> = React.memo((props) => {
  const { sections } = props;
  return (
    <ul className="flex flex-col">
      {sections.map((section, index) => (
        <li key={index} className="not-last:border-b-2 border-purple/50 py-4 gap-2 flex flex-col">
          <h4 className="font-semibold">{section.title}</h4>
          <p>{section.content}</p>
        </li>
      ))}
    </ul>
  );
});
FAQPanel.displayName = 'FAQPanel';
